import { BASEURL, ENDPOINTS, SPXAPI } from '@/api';

export interface ServerSignUpResponse {
    userSub: string;
    userConfirmed: boolean;
}

export interface ServerSignUpRequest {
    email: string;
    password: string;
    clientMetadata?: Record<string, string>;
    linkId?: string;
}

export const serverSignUp = async (
    APIInstance: SPXAPI,
    { email, password, clientMetadata, linkId }: ServerSignUpRequest,
): Promise<ServerSignUpResponse> => (
    APIInstance.post(BASEURL.backend(), ENDPOINTS.signUp(), {
        body: {
            email: email.toLowerCase(),
            password,
            clientMetadata,
            ...(linkId ? { linkId } : {}),
        },
    })
);
